import { useState } from 'react';

import { IconUsers } from '../../../common/icons';
import { useCombobox } from '../../../common/hooks/use-combobox';
import { useUsersList } from '../contexts/users';

// Reuses the typeahead styles from the clients searcher.
import '../../clients/styles/search.css';

// User typeahead. The /admin/users endpoint has no `q` param (and no
// api-reference yet), so we fetch up to 100 and filter client-side by
// name/email/username. Flagged to the orchestrator: add server-side search.

export default function UserSelect({ onSelect, placeholder = 'Buscar usuario…', autoFocus = false }) {
    const { data } = useUsersList({ limit: 100 });
    const users = data?.items ?? [];

    const [text, setText] = useState('');

    const q = text.trim().toLowerCase();
    const matches = (q
        ? users.filter(u => [u.name, u.email, u.username].some(v => (v || '').toLowerCase().includes(q)))
        : users
    ).slice(0, 25);

    const choose = (u) => { setText(u.name); onSelect?.(u); };
    const cb = useCombobox({ items: matches, onChoose: choose });

    return (
        <div className="search">
            <input
                type="text"
                className="search__input"
                value={text}
                placeholder={placeholder}
                autoFocus={autoFocus}
                role="combobox"
                aria-autocomplete="list"
                aria-expanded={cb.open}
                aria-controls={cb.listId}
                aria-activedescendant={cb.activeId}
                onChange={(e) => { setText(e.target.value); cb.setOpen(true); }}
                onFocus={cb.onFocus}
                onBlur={cb.onBlur}
                onKeyDown={cb.onKeyDown}
            />
            {cb.open && (
                <div className="search__panel" role="listbox" id={cb.listId}>
                    {!matches.length ? (
                        <p className="search__hint">Sin usuarios.</p>
                    ) : (
                        matches.map((u, i) => (
                            <button
                                key={u.id}
                                type="button"
                                id={cb.optionId(i)}
                                role="option"
                                aria-selected={cb.activeIndex === i}
                                className={`search__item ${cb.activeIndex === i ? 'search__item--active' : ''}`}
                                onMouseDown={cb.onOptionMouseDown(u)}
                                onMouseEnter={() => cb.setActive(i)}
                            >
                                <span className="search__item-icon"><IconUsers /></span>
                                <span className="search__item-body">
                                    <span className="search__item-name">{u.name}</span>
                                    {(u.email || u.role) && (
                                        <span className="search__item-sub">
                                            {[u.email, u.role].filter(Boolean).join(' · ')}
                                        </span>
                                    )}
                                </span>
                            </button>
                        ))
                    )}
                </div>
            )}
        </div>
    );
}
